import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminContractTable from "../../../components/admin/client/contract/AdminContractTable";

//어드민 계약 페이지
const AdminContractPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*어드민 계약 테이블*/}
            <AdminContractTable/>
        </AdminLayout>
    )
}
export default AdminContractPage;